import React from 'react'
import classNames from 'classnames'

import Grid, { GridProps } from '@material-ui/core/Grid'
import ListItem, { ListItemProps } from '@material-ui/core/ListItem'
import Typography, { TypographyProps } from '@material-ui/core/Typography'
import { withStyles, Collapse, createStyles, WithStyles, Theme } from '@material-ui/core'

import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

import { Omit } from 'types'

interface Props extends Omit<ListItemProps, 'classes'> {
  headline: React.ReactNode
  subtitle?: React.ReactNode
  leftChild?: React.ReactNode
  rightChild?: React.ReactNode
  dropdownChild?: React.ReactNode
  headlineVariant?: TypographyProps['variant']
  subtitleVariant?: TypographyProps['variant']
  xs?: GridProps['xs']
  isDropdownActive?: boolean
  isMarked?: boolean
}

const styles = (theme: Theme) => createStyles({
  root: {
    position: 'relative',
  },
  marked: {
    top: 0,
    left: 0,
    width: 6,
    height: '100%',
    position: 'absolute',
    backgroundColor: theme.palette.primary.main,
  },
  selected: {
    backgroundColor: theme.palette.grey['300'],
  },
  selectedMarked: {
    backgroundColor: theme.palette.primary.main,
  },
  leftChildContainer: {
    marginRight: theme.spacing() * 2,
  },
  dropdownChildContainer: {
    borderLeftWidth: theme.spacing(),
    borderLeftStyle: 'solid',
    borderLeftColor: theme.palette.grey['300'],
  },
  dropdownChildContainerMarked: {
    borderLeftColor: theme.palette.primary.main,
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const GeneralListItem: React.SFC<InjectedProps> = ({
  classes,
  headline,
  subtitle,
  leftChild,
  rightChild,
  dropdownChild,
  headlineVariant,
  subtitleVariant,
  xs,
  isDropdownActive,
  isMarked,
  children,
  className,
  ...props
}) => {
  return (
    <>
      <ListItem
        divider
        button={Boolean(dropdownChild) && !isDropdownActive as any} // bocsmá
        className={classNames(
          className,
          classes.root,
          {
            [classes.selected]: isDropdownActive,
            [classes.selectedMarked]: isDropdownActive && isMarked,
          }
        )}
        {...props}
      >
        {isMarked && <div className={classes.marked} />}
        {leftChild && (
          <Grid item className={classes.leftChildContainer}>
            {leftChild}
          </Grid>
        )}
        <Grid item xs container alignItems="center">
          <Grid item xs={xs || true} container direction="column">
            <Grid item>
              <Typography component="div" variant={headlineVariant || 'body1'}>
                {headline}
              </Typography>
            </Grid>
            <Grid item>
              <Typography component="div" variant={subtitleVariant || 'body2'}>
                {subtitle}
              </Typography>
            </Grid>
          </Grid>
          {children}
          {rightChild && (
            <Grid item>
              {rightChild}
            </Grid>
          )}
          {dropdownChild && (
            <Grid item>
              {isDropdownActive
                ? <ExpandLess style={{ display: 'block' }} />
                : <ExpandMore style={{ display: 'block' }} />
              }
            </Grid>
          )}
        </Grid>
      </ListItem>
      {dropdownChild && (
        <Collapse in={isDropdownActive} timeout="auto" unmountOnExit>
          <div
            className={classNames(
              classes.dropdownChildContainer,
              { [classes.dropdownChildContainerMarked]: isMarked }
            )}
          >
            {dropdownChild}
          </div>
        </Collapse>
      )}
    </>
  )
}

export default withStyles(styles)(GeneralListItem)
